import { BlogSection } from '@/types/blog';

export const fazit: BlogSection = {
  id: 'fazit',
  title: 'Fazit: Was bleibt',
  content: `
    <p>Fromm bietet keine schnellen Lösungen. Keine 5-Schritte-Formel zur perfekten Liebe. Keine Hacks für mehr Umsatz.</p>

    <p>Er bietet etwas Selteneres: <strong>Klarheit.</strong></p>

    <p>Klarheit darüber, <em>wie</em> wir leben wollen.</p>

    <div class="grid md:grid-cols-2 gap-8 my-10">
      <div class="bg-gradient-to-br from-joerg-50/80 to-joerg-100/40 dark:from-joerg-800/40 dark:to-joerg-900/30 p-8 rounded-xl border border-joerg-200/60 dark:border-joerg-700/40">
        <h4 class="font-bold text-joerg-800 dark:text-joerg-100 mb-4 text-lg">Haben-Modus</h4>
        <p class="text-joerg-700 dark:text-joerg-300 leading-relaxed">Wo alles zum Besitz wird – festgehalten, gezählt, verglichen.<br/>Sicher geglaubt, doch innerlich fragil.</p>
      </div>
      <div class="bg-gradient-to-br from-sage-50/80 to-primary/5 dark:from-sage-900/40 dark:to-primary/15 p-8 rounded-xl border border-sage-200/60 dark:border-sage-700/40">
        <h4 class="font-bold text-joerg-800 dark:text-joerg-100 mb-4 text-lg">Sein-Modus</h4>
        <p class="text-joerg-700 dark:text-joerg-300 leading-relaxed">Wo alles im Fluss bleibt – erlebt, geteilt, gewachsen.<br/>Kein Festhalten nötig, weil es aus sich selbst lebt.</p>
      </div>
    </div>

    <p class="text-lg font-semibold text-joerg-800 dark:text-joerg-100">Das ist keine Theorie. Das ist eine Entscheidung.</p>
    <p class="text-lg font-semibold text-joerg-800 dark:text-joerg-100">Jeden Tag. In jedem Moment.</p>

    <p class="text-xl font-bold text-joerg-800 dark:text-joerg-100 mt-8">Wie entscheidest du dich?</p>
  `
};
